import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../../index';
import { LogoProps, DEFAULT_IMAGE_SIZE } from '../../Icon/icon';
import LogoIconSvg from '../LogoIconSvg';

const PaybackBrandBig = (props: LogoProps) => {
  const [t] = useTranslation();
  const {
    id,
    dmId = 'dm-payback-brand-big',
    pointerEvents = 'none',
    size = DEFAULT_IMAGE_SIZE,
    ...otherProps
  } = props;

  const title = t('ds.logo.paybackBrand.title');
  const viewBox = '0 0 20 7.76';

  return (
    <LogoIconSvg
      id={id}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      viewBox={viewBox}
      {...otherProps}>
      <path
        fill={theme.palette.color5.hex}
        d="M1.32,7.76C0.6,7.76,0,7.15,0,6.43V1.32C0,0.6,0.6,0,1.32,0h17.36C19.4,0,20,0.6,20,1.32v5.11
		c0,0.72-0.6,1.32-1.32,1.32H1.32z"
      />
      <path
        fill="#0046AA"
        d="M19.54,6.43c0,0.48-0.38,0.84-0.84,0.84H1.32c-0.48,0-0.84-0.38-0.84-0.84V1.32c0-0.46,0.38-0.84,0.84-0.84
		h17.36c0.48,0,0.84,0.38,0.84,0.84L19.54,6.43L19.54,6.43z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M13.93,1.58c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			S14.29,1.58,13.93,1.58z M13.93,2.83c-0.31,0-0.58-0.26-0.58-0.58s0.24-0.58,0.58-0.58c0.31,0,0.58,0.26,0.58,0.58
			C14.5,2.59,14.24,2.83,13.93,2.83z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M15.53,1.58c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			S15.92,1.58,15.53,1.58z M15.53,2.83c-0.31,0-0.58-0.26-0.58-0.58s0.26-0.58,0.58-0.58c0.31,0,0.58,0.26,0.58,0.58
			C16.11,2.59,15.85,2.83,15.53,2.83z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M17.14,1.58c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			C17.84,1.9,17.53,1.58,17.14,1.58z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M13.93,4.83c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			C14.6,5.11,14.29,4.83,13.93,4.83z M13.93,6.07c-0.31,0-0.58-0.26-0.58-0.58s0.26-0.58,0.58-0.58S14.5,5.19,14.5,5.5
			C14.5,5.81,14.24,6.07,13.93,6.07z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M15.53,4.83c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			C16.21,5.11,15.92,4.83,15.53,4.83z M15.53,6.07c-0.31,0-0.58-0.26-0.58-0.58s0.26-0.58,0.58-0.58c0.31,0,0.58,0.26,0.58,0.58
			C16.11,5.81,15.85,6.07,15.53,6.07z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M17.14,4.83c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			C17.84,5.11,17.53,4.83,17.14,4.83z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M13.93,3.19c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			S14.29,3.19,13.93,3.19z M13.93,4.47c-0.31,0-0.58-0.26-0.58-0.58s0.26-0.58,0.58-0.58s0.58,0.26,0.58,0.58S14.24,4.47,13.93,4.47
			z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M15.53,3.19c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			S15.92,3.19,15.53,3.19z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M17.14,3.19c-0.38,0-0.67,0.31-0.67,0.67c0,0.38,0.31,0.67,0.67,0.67c0.38,0,0.67-0.31,0.67-0.67
			C17.84,3.51,17.53,3.19,17.14,3.19z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M2.42,2.42c-0.24,0-0.43,0.19-0.43,0.43s0.19,0.43,0.43,0.43S2.86,3.1,2.86,2.86
		C2.86,2.62,2.67,2.42,2.42,2.42z M2.42,3.19c-0.17,0-0.31-0.14-0.31-0.31s0.14-0.31,0.31-0.31c0.17,0,0.31,0.14,0.31,0.31
		C2.76,3.03,2.62,3.19,2.42,3.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme.palette.color5.hex}
        d="M4.25,2.98c0-0.34-0.22-0.46-0.53-0.46h-0.6v1.37h0.38V3.46H3.7C4.01,3.43,4.25,3.31,4.25,2.98L4.25,2.98z
			 M3.87,2.98c0,0.12-0.05,0.17-0.19,0.17H3.46V2.83h0.22C3.82,2.81,3.87,2.88,3.87,2.98L3.87,2.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme.palette.color5.hex}
        d="M5.59,3.89l-0.5-1.37H4.71L4.2,3.89h0.38l0.07-0.26h0.48l0.07,0.26H5.59L5.59,3.89z M5.09,3.36H4.73l0.05-0.1
			C4.85,3.05,4.9,2.98,4.92,2.86c0.02,0.12,0.07,0.19,0.14,0.41L5.09,3.36L5.09,3.36z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M6.41,2.52l-0.1,0.22C6.24,2.88,6.19,3,6.15,3.1l0,0C6.12,3.03,6.07,2.88,6,2.76l-0.1-0.22H5.47l0.5,0.86v0.5
			h0.38V3.36l0.5-0.86H6.41C6.41,2.5,6.41,2.52,6.41,2.52z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme.palette.color5.hex}
        d="M8.19,3.43c0-0.14-0.07-0.24-0.19-0.31C8.09,3.07,8.16,3,8.16,2.86c0-0.22-0.14-0.36-0.48-0.36H7.01v1.37
			h0.67C8.02,3.89,8.19,3.72,8.19,3.43L8.19,3.43z M7.8,2.93C7.8,3,7.78,3.05,7.68,3.05H7.37V2.81h0.31C7.78,2.81,7.8,2.86,7.8,2.93
			L7.8,2.93z M7.83,3.46c0,0.1-0.05,0.14-0.14,0.14H7.35V3.31h0.34C7.78,3.31,7.83,3.36,7.83,3.46L7.83,3.46z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={theme.palette.color5.hex}
        d="M9.68,3.89l-0.5-1.37H8.79l-0.5,1.37h0.38l0.07-0.26h0.48l0.07,0.26H9.68L9.68,3.89z M9.15,3.36H8.79
			l0.05-0.1c0.07-0.22,0.12-0.29,0.14-0.41C9,2.98,9.05,3.05,9.12,3.27L9.15,3.36L9.15,3.36z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M10.95,3.55l-0.31-0.17c-0.07,0.12-0.12,0.19-0.24,0.19c-0.17,0-0.24-0.17-0.24-0.38
			c0-0.22,0.07-0.38,0.22-0.38c0.12,0,0.17,0.07,0.22,0.22l0.34-0.14c-0.1-0.26-0.22-0.41-0.58-0.41c-0.36,0-0.62,0.26-0.62,0.7
			c0,0.41,0.22,0.7,0.62,0.7C10.68,3.89,10.85,3.72,10.95,3.55L10.95,3.55z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M12.41,3.89L11.96,3l0.41-0.48h-0.43l-0.12,0.14c-0.1,0.1-0.22,0.26-0.29,0.34l0,0c0-0.1,0-0.22,0-0.34V2.5
			h-0.38v1.37h0.38V3.46l0.14-0.17l0,0l0.31,0.58L12.41,3.89L12.41,3.89z"
      />
    </LogoIconSvg>
  );
};

export default memo(PaybackBrandBig);
